<template>
<vx-card class='vx-col w-full mt-4'>
    <vs-tabs>
        <vs-tab label="Instituciones">
            <Instituciones/>
        </vs-tab>
        <vs-tab label="Periodos" v-if="permisoRoot">
            <Periodos />
        </vs-tab>
    </vs-tabs>
</vx-card>
</template>

<script>
import Periodos from '../periodos/periodos.vue';
import Instituciones from './Instituciones.vue';
import GeneralMixin from "@/mixins/GeneralMixin";
export default {
    mixins: [GeneralMixin],
    components: {
        Periodos,
        Instituciones
    },
    data() {
        return {
            permisoRoot: false,
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.getUserRoot().then(r => {
            if (r.data.length > 0) {
                me.permisoRoot = true
            }
        })
    },
    methods: {}
};
</script>
